var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDubaiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "582px",
    height: "800px",
    viewBox: "0 0 582 800",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "burj-al-arab-dubai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "burj-al-arab-dubai",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.635938,472.726562 L254.545313,472.726562 C234.4625,472.726562 218.18125,489.007812 218.18125,509.090625 C218.18125,529.173438 234.4625,545.454688 254.545313,545.454688 L363.635938,545.454688 C383.71875,545.454688 400,529.173438 400,509.090625 C400,489.007812 383.720313,472.726562 363.635938,472.726562 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.545313,436.364062 L327.271875,436.364062 C347.354688,436.364062 363.635938,420.082812 363.635938,400 C363.635938,379.917187 347.354688,363.635937 327.271875,363.635937 L254.545312,363.635937 C234.4625,363.635937 218.18125,379.917187 218.18125,400 C218.18125,420.082812 234.4625,436.364062 254.545313,436.364062 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.635938,581.81875 L254.545313,581.81875 C234.4625,581.81875 218.18125,598.1 218.18125,618.182812 C218.18125,638.265625 234.4625,654.546875 254.545313,654.546875 L363.635938,654.546875 C383.71875,654.546875 400,638.265625 400,618.182812 C400,598.098437 383.720313,581.81875 363.635938,581.81875 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.454687,727.273438 L505.523438,727.273438 C516.5,681.86875 521.64375,638.475 521.64375,595.01875 C521.64375,560.376562 518.078125,525.851562 510.9875,491.85 C481.532813,350.020312 403.825,225.064063 289.775,144.159375 C255.414063,119.79375 216.925,97.828125 181.81875,83.55625 L181.81875,36.3640625 C181.81875,16.28125 165.5375,0 145.454688,0 C125.371875,0 109.090625,16.28125 109.090625,36.3640625 L109.090625,109.090625 C109.090625,109.1875 109.096875,109.28125 109.098437,109.378125 L109.098437,727.273438 L36.3640625,727.273438 C16.28125,727.273438 0,743.554688 0,763.6375 C0,783.720312 16.28125,800 36.3640625,800 L145.4625,800 L455.171875,800 L545.45625,800 C565.539062,800 581.820312,783.71875 581.820312,763.635937 C581.820312,743.553125 565.5375,727.273438 545.454687,727.273438 Z M181.825,727.273438 L181.825,163.5 C203.692187,174.595313 226.632813,188.542188 247.7,203.48125 C346.246875,273.3875 413.946875,382.251563 439.784375,506.667188 C445.8625,535.81875 448.915625,565.367188 448.915625,595.01875 C448.915625,633.309375 444.328125,671.565625 435.245312,709.08125 L429.0875,727.273438 L181.825,727.273438 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDubaiIcon);
export default __webpack_public_path__ + "static/media/dubai-icon.48fd15c0b73f407982ad563ced498f55.svg";
export { ForwardRef as ReactComponent };